import React from 'react';
import ReactDOM from 'react-dom';
import Grid from './modules/GridModule';
import PartnerConnect from './modules/PartnerConnectModule';
import ChatPaneWrapper from './modules/ChatPane';
import SpeakersPreview from './modules/SpeakersPreviewModule';
import UsersPreview from './modules/UsersPreviewModule';
import PartnerBookTalk from './modules/PartnerBookTalk';
import QuickAnalytics from './modules/QuickAnalytics';
// import ChatPane from './modules/ChatPane'
import SendToBreakoutsLoader from './components/SendToBreakoutsLoader';
import NotificationModule from './modules/NotificationModule/index';
import JUNOSwitch from './components/JUNOSwitch/index';
import JUNOSelect from './components/JUNOSelect';
import JUNOPushNotification from './components/JUNOPushNotification';
import GroupPointsModule from './modules/GroupPointsModule';
import NotificationPrefModule from './modules/NotificationPrefModule/index';
import ProfileDropdownModule from './modules/ProfileDropdown';
import AdminNotficationsModule from './modules/AdminNotficationsModule';
import MyScheduleRowModule from './modules/MyScheduleRowModule';
import JUNOAddToCalendarButton from './components/JUNOAddToCalendarButton';
import PushNotificationHandler from '../utils/PushNotificationHandler';

// This is our factory for react components. Going to run them ALL through here so we only
// are attaching all this compiled es6 to the window in one place.

export default function ReactComponent() {
  ReactComponent.prototype.inject = function (type: string, container: JQuery<HTMLElement>, props: any) {
    // Sometimes we want to pass a container and the parent injects it, sometimes
    // we don't pass a container and have to create the div ourselves

    this.mDiv = $(
      // @ts-ignore
      HGEN.tree({
        style: `React_${type}`,
      }),
    );

    if (container) {
      this.mDiv = container;
    }

    // The factory the makes miniature models of factories (commented these suckers out until we actually commit the components)
    switch (type) {
      case 'ChatPane':
        ReactDOM.render(<ChatPaneWrapper {...props} />, this.mDiv[0]);
        break;
      case 'GridModule':
        ReactDOM.render(<Grid props={props} />, this.mDiv[0]);
        break;
      case 'PartnerConnectModule':
        ReactDOM.render(<PartnerConnect {...props} />, this.mDiv[0]);
        break;
      case 'SpeakersPreviewModule':
        ReactDOM.render(<SpeakersPreview {...props} />, this.mDiv[0]);
        break;
      case 'UsersPreviewModule':
        ReactDOM.render(<UsersPreview {...props} />, this.mDiv[0]);
        break;
      case 'PartnerBookTalk':
        ReactDOM.render(<PartnerBookTalk {...props} />, this.mDiv[0]);
        break;
      case 'QuickAnalyticsModule':
        ReactDOM.render(<QuickAnalytics {...props} />, this.mDiv[0]);
        break;
      case 'SendToBreakoutsLoader':
        ReactDOM.render(<SendToBreakoutsLoader {...props} />, this.mDiv[0]);
        break;
      case 'NotificationModule':
        ReactDOM.render(<NotificationModule {...props} />, this.mDiv[0]);
        break;
      case 'JUNOSwitch':
        ReactDOM.render(<JUNOSwitch {...props} />, this.mDiv[0]);
        break;
      case 'JUNOSelect':
        ReactDOM.render(<JUNOSelect {...props} />, this.mDiv[0]);
        break;
      case 'JUNOPushNotification':
        ReactDOM.render(<JUNOPushNotification {...props} />, this.mDiv[0]);
        break;
      case 'GroupPointsModule':
        ReactDOM.render(<GroupPointsModule {...props} />, this.mDiv[0]);
        break;
      case 'NotificationPrefModule':
        ReactDOM.render(<NotificationPrefModule {...props} />, this.mDiv[0]);
        break;
      case 'ProfileDropdownModule':
        ReactDOM.render(<ProfileDropdownModule {...props} />, this.mDiv[0]);
        break;
      case 'AdminNotficationsModule':
        ReactDOM.render(<AdminNotficationsModule {...props} />, this.mDiv[0]);
        break;
      case 'PushNotificationHandler':
        ReactDOM.render(<PushNotificationHandler {...props} />, this.mDiv[0]);
        break;
      case 'MyScheduleRowModule':
        ReactDOM.render(<MyScheduleRowModule {...props} />, this.mDiv[0]);
        break;
      case 'AddToCalendarButton':
        ReactDOM.render(<JUNOAddToCalendarButton {...props} />, this.mDiv[0]);
        break;
      default:
    }

    return this.mDiv;
  };

  ReactComponent.prototype.destroy = function () {
    // clean that shit up
    ReactDOM.unmountComponentAtNode(this.mDiv[0]);
  };
}
